<template>
<div>
  <text-area 
    :value="item" 
    v-for="(item, index) in payload" :key="index">
    {{ index }}  
  </text-area>  
</div>  
</template>
<script>
export default {
  
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>